import FormBuilder from "../../../../shared/components/FormBuilder";
import { HeaderComponent } from "../../../../shared/components/HeaderComponent";
import { Loader } from "../../../../shared/components/Loader";
import { Box } from "@mui/material"; 
import { Button } from "../../../../shared/components/button/Button";
import * as Icon from '@mui/icons-material/';
import ComponentTable from "../../../Components/Table/Index";
import useReajusteEstoquePesquisar from "../../../../hooks/useReajusteEstoquePesquisar";

export default function ReajusteEstoquePesquisar() {
    const {
        loading,
        initialValues,
        tableColumns,
        tableRows,
        fields,
        handleSubmit,
        handleNavigation
    } = useReajusteEstoquePesquisar();

    return (
        <Loader loading={loading}>
            <Box>
                <HeaderComponent text={'Reajuste de Estoque'}
                    ButtonRight={
                        <Button title={'Incluir'} variant='success' onClick={handleNavigation} iconStart={<Icon.Add />} />
                    }
                />
                <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />                
                <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
                    // handleEditItem(row, true, row.Id);
                }} />
            </Box>
        </Loader>
    );
}